// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnalyticsDashboard_page__YeEit {
  padding: 20px;
  font-family: "Segoe UI", Arial, sans-serif;
  background: #f5f7fa;
  min-height: 100vh;
}

.AnalyticsDashboard_title__gdx8J {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #222;
}

.AnalyticsDashboard_filters__aqvBS {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.AnalyticsDashboard_filters__aqvBS input[type="date"] {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
}

.AnalyticsDashboard_filters__aqvBS button {
  padding: 6px 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.AnalyticsDashboard_filters__aqvBS button:hover {
  background: #0056b3;
}

.AnalyticsDashboard_checkbox__ws1u- {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  cursor: pointer;
}

.AnalyticsDashboard_kpis__yTxIf {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.AnalyticsDashboard_kpiCard__mJzb- {
  flex: 1 1;
  background: white;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  min-width: 150px;
}

.AnalyticsDashboard_kpiCard__mJzb- h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #555;
}

.AnalyticsDashboard_kpiCard__mJzb- p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 6px;
  color: #222;
}

.AnalyticsDashboard_chartBox__2ZupM {
  background: white;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  margin-bottom: 30px;
}

.AnalyticsDashboard_cards__2VAUW {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 10px;
}

.AnalyticsDashboard_card__xaUzp {
  background: white;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.AnalyticsDashboard_card__xaUzp:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  background: #f9fafb;
}

.AnalyticsDashboard_card__xaUzp h3 {
  margin: 0;
  font-size: 18px;
  color: #222;
}

.AnalyticsDashboard_card__xaUzp p {
  margin: 4px 0;
  font-size: 14px;
  color: #666;
}

.AnalyticsDashboard_percent__VcOIW {
  font-weight: bold;
  font-size: 18px;
  margin-top: 8px;
  color: #333; /* нейтральный цвет */
}

/* модалка */
.AnalyticsDashboard_modalOverlay__U3-D0 {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.AnalyticsDashboard_modal__dQh8b {
  background: white;
  padding: 20px;
  border-radius: 12px;
  max-width: 700px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  animation: AnalyticsDashboard_fadeIn__TkL2x 0.2s ease-in-out;
}

.AnalyticsDashboard_modal__dQh8b h2 {
  margin-top: 0;
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

.AnalyticsDashboard_modal__dQh8b button {
  margin-top: 20px;
  padding: 8px 16px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.AnalyticsDashboard_modal__dQh8b button:hover {
  background: #0056b3;
}

/* тултип */
.AnalyticsDashboard_tooltipBox__yW\\+ZZ {
  background: #fff;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  font-size: 14px;
  color: #222;
}

@keyframes AnalyticsDashboard_fadeIn__TkL2x {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/AnalyticsDashboard/AnalyticsDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW,EAAE,qBAAqB;AACpC;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,4DAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".page {\r\n  padding: 20px;\r\n  font-family: \"Segoe UI\", Arial, sans-serif;\r\n  background: #f5f7fa;\r\n  min-height: 100vh;\r\n}\r\n\r\n.title {\r\n  font-size: 26px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  color: #222;\r\n}\r\n\r\n.filters {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.filters input[type=\"date\"] {\r\n  padding: 6px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  background: white;\r\n}\r\n\r\n.filters button {\r\n  padding: 6px 12px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.filters button:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.kpis {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.kpiCard {\r\n  flex: 1;\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\r\n  min-width: 150px;\r\n}\r\n\r\n.kpiCard h3 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  color: #555;\r\n}\r\n\r\n.kpiCard p {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-top: 6px;\r\n  color: #222;\r\n}\r\n\r\n.chartBox {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 14px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.cards {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 16px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  text-align: center;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n  cursor: pointer;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.12);\r\n  background: #f9fafb;\r\n}\r\n\r\n.card h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: #222;\r\n}\r\n\r\n.card p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.percent {\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  margin-top: 8px;\r\n  color: #333; /* нейтральный цвет */\r\n}\r\n\r\n/* модалка */\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0; left: 0;\r\n  width: 100%; height: 100%;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 12px;\r\n  max-width: 700px;\r\n  width: 90%;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 4px 20px rgba(0,0,0,0.2);\r\n  animation: fadeIn 0.2s ease-in-out;\r\n}\r\n\r\n.modal h2 {\r\n  margin-top: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #222;\r\n}\r\n\r\n.modal button {\r\n  margin-top: 20px;\r\n  padding: 8px 16px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.modal button:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n/* тултип */\r\n.tooltipBox {\r\n  background: #fff;\r\n  padding: 8px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1);\r\n  font-size: 14px;\r\n  color: #222;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(-5px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AnalyticsDashboard_page__YeEit`,
	"title": `AnalyticsDashboard_title__gdx8J`,
	"filters": `AnalyticsDashboard_filters__aqvBS`,
	"checkbox": `AnalyticsDashboard_checkbox__ws1u-`,
	"kpis": `AnalyticsDashboard_kpis__yTxIf`,
	"kpiCard": `AnalyticsDashboard_kpiCard__mJzb-`,
	"chartBox": `AnalyticsDashboard_chartBox__2ZupM`,
	"cards": `AnalyticsDashboard_cards__2VAUW`,
	"card": `AnalyticsDashboard_card__xaUzp`,
	"percent": `AnalyticsDashboard_percent__VcOIW`,
	"modalOverlay": `AnalyticsDashboard_modalOverlay__U3-D0`,
	"modal": `AnalyticsDashboard_modal__dQh8b`,
	"fadeIn": `AnalyticsDashboard_fadeIn__TkL2x`,
	"tooltipBox": `AnalyticsDashboard_tooltipBox__yW+ZZ`
};
export default ___CSS_LOADER_EXPORT___;
